/**
 * GraphQL queries and hooks — analytics pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { AnalyticsSummary } from '../types/analytics';

export const GET_ANALYTICS_SUMMARY = gql`
  query GetAnalyticsSummary {
    analyticsQuery {
      entityCounts {
        services {
          total
          byStatus
        }
        capabilities {
          total
          byStatus
        }
        dataDomains {
          total
          byStatus
        }
        technologies {
          total
          byStatus
        }
      }
      pillarHealthScores {
        application {
          score
          total
          complete
          factors
        }
        business {
          score
          total
          complete
          factors
        }
        information {
          score
          total
          complete
          factors
        }
        technology {
          score
          total
          complete
          factors
        }
      }
      maturityDistribution {
        level1
        level2
        level3
        level4
        level5
        level6
        averageScore
        totalAssessments
      }
      auditActivity {
        last30Days {
          total
          byAction
        }
        last90Days {
          total
          byAction
        }
        activeUsers30Days
        activeUsersByPeriod {
          lastWeek
          lastMonth
          lastQuarter
          lastYear
        }
      }
    }
  }
`;

export function useAnalyticsSummary(): QueryResult<{ analyticsQuery: AnalyticsSummary }> {
  return useQuery(GET_ANALYTICS_SUMMARY, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
}
